import { Component, forwardRef, Input, OnInit } from '@angular/core'
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms'
import { FormControlValueAccessor } from '@mistergreen/shared/angular-directives/abstract-value-accessor'
import { validateEmail } from '../../../../framework/utilities/validateEmail'

let _uniqueIdCounter: number = 0

@Component({
    selector: 'mg-email-input',
    templateUrl: './email-input.component.html',
    styleUrls: ['./email-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EmailInputComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => EmailInputComponent),
            multi: true,
        },
    ],
})
export class EmailInputComponent extends FormControlValueAccessor implements OnInit {
    @Input() public id: string = `email-input-component-${_uniqueIdCounter++}`

    @Input() altStyling: boolean = false

    @Input() required = true

    @Input() placeholder: string | null = null

    ngOnInit(): void {
        this.componentFormControl.setValidators(this.validate.bind(this))
    }

    validate() {
        return (!this.value && !this.required) || (this.value && this.value.length && validateEmail(this.value))
            ? null
            : { email: false }
    }
}
